import { P2GBox } from '@parcel2go/peacock-legacy-core/dist/box';
import { P2GGrid } from '@parcel2go/peacock-legacy-core/dist/grid';
import { P2GText } from '@parcel2go/peacock-legacy-core/dist/typography';
import { P2GBadge } from '@parcel2go/peacock-legacy-core/dist/badge';
import React, { useMemo } from 'react';
import { ActionType, Integration, IntegrationType } from '../services/api/types';
import IntegrationBox from './IntegrationBox';
import { P2GFade } from '@parcel2go/peacock-legacy-core/dist/transitions';

interface props {
  integrations: Integration[];
  type: IntegrationType;
  onComplete: (accountId: string, followUpAction?: ActionType) => void;
  editAccount: (accountId: string, action: ActionType) => void;
}

export default function IntegrationTypeSummary(props: props) {
  const title = useMemo(() => {
    switch (props.type) {
      case 'Courier':
        return 'The Following Courier Accounts are available to integrate';
      case 'Marketplace':
        return 'The Following Sales Channels are available to integrate';
      default:
        return `The following ${props.type} integrations are available`;
    }
  }, [props.type]);

  if (!props.integrations || props.integrations.length === 0) {
    return null;
  }

  return (
    <P2GBox mt={2} mb={2}>
      {title && (
        <P2GBox mb={2}>
          <P2GText component="p">{title}</P2GText>
        </P2GBox>
      )}
      <P2GGrid container spacing={2}>
        {props.integrations.map((integrations, index) => (
          <P2GGrid item xs={6} md={2} key={`${integrations.type}_${integrations.slug}`}>
            <P2GFade in timeout={(index + 1) * 550}>
              <div style={{ position: 'relative' }}>
                <div style={{ position: 'absolute', right: 15, top: 5 }}>
                  <P2GBadge colour="secondary" badgeContent={integrations.accounts.length} />
                </div>
                <IntegrationBox
                  integration={integrations}
                  editAccount={props.editAccount}
                  onComplete={props.onComplete}
                />
              </div>
            </P2GFade>
          </P2GGrid>
        ))}
      </P2GGrid>
    </P2GBox>
  );
}
